import { Component, OnInit } from "@angular/core";
import { SplashScreenService } from "@services/generic/splash-screen.service";

@Component({
  selector: "app-error-screen",
  templateUrl: "./error-screen.component.html",
  styleUrls: ["./error-screen.component.scss"],
})
export class ErrorScreenComponent implements OnInit {
  constructor(public splashSvc: SplashScreenService) {}

  ngOnInit() {
    this.splashSvc.activateSplash(true);
  }
}
